import { Divider } from "@launchmetrics/lm-ui";


export const SidePanelFooter = (props: any) => {
	return (
		<>
			<Divider orientation='horizontal'></Divider>
			<div className='side-panel-footer'>
				{props.children}
			</div>
		</>
	);
};
